<template>
    <div class="form-row">
        <div class="form-group col-7 bax-form-group">
            <label for="consumable_name" v-if="index === 0">Consumable</label>
            <select v-model="formData.consumables_list[index].name" class="form-control">
                <option class="d-none" value="">- Select -</option>
                <option value="none">Not Required</option>
                <optgroup  v-for="(group, index) in defaultSettings.consumablesList" :label="group.name" v-bind:key="index">
                    <option v-for="(item, index2) in group.items" :value="item" v-bind:key="index2">
                        {{ item }}
                    </option>
                </optgroup>
            </select>
            <span class="form-error" v-if="$v.formData.consumables_list.$each[index].name.$dirty && !$v.formData.consumables_list.$each[index].name.required">Required field</span>
        </div>
        <div class="col-5" v-if="formData.consumables_list[index].name !== '' && formData.consumables_list[index].name !== 'none'">
            <div class="form-row">
                <div class="form-group col-3">
                    <label for="consumable_qty" v-if="index === 0">Qty *</label>
                    <input type="text" class="form-control" v-model="formData.consumables_list[index].qty">
                    <span class="form-error" v-if="$v.formData.consumables_list.$each[index].qty.$dirty && !$v.formData.consumables_list.$each[index].qty.required">Required field</span>
                </div>
                <div class="form-group col-9">
                    <label for="consumable_frequency" v-if="index === 0">Frequency *</label>
                    <select v-model="formData.consumables_list[index].frequency" class="form-control">
                        <option class="d-none" value="">- Select -</option>
                        <option v-for="(item, index) in frequencyOptions" :value="item" v-bind:key="index">
                            {{ item }}
                        </option>
                    </select>
                    <span class="form-error" v-if="$v.formData.consumables_list.$each[index].frequency.$dirty && !$v.formData.consumables_list.$each[index].frequency.required">Required field</span>
                </div>
            </div>
        </div>
        <button class="consumable-delete" v-on:click="removeConsumableRow" v-if="index !== 0"></button>
    </div>
</template>


<script>

import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
    name: 'ConsumableRow',
    components: {
    },
    data() {
        return {
            frequencyOptions: [
                'Daily',
                'Weekly',
                'Monthly',
                'Every second month',
            ],
        };
    },
    props: {
        formData: {
            required: true,
        },
        index: {
            required: true,
        },
        item: {
            required: true,
        },
        defaultSettings: {
            required: true,
        },
    },
    validations: {
        formData: {
            consumables_list: {
                $each: {
                    name: {
                        required,
                    },
                    qty: {
                        required: requiredIf(function () {
                            if (this.formData.consumables_list[this.index].name !== '' && this.formData.consumables_list[this.index].name !== 'none') {
                                return true;
                            }
                            return false;
                        }),
                    },
                    frequency: {
                        required: requiredIf(function () {
                            if (this.formData.consumables_list[this.index].name !== '' && this.formData.consumables_list[this.index].name !== 'none') {
                                return true;
                            }
                            return false;
                        }),
                    },
                },
            },
        },
    },
    computed: {
    },
    methods: {
        removeConsumableRow() {
            this.formData.consumables_list.splice(this.index, 1);
        },
        validateForm() {
            this.$v.$touch();
            this.$emit('consumables_validation_response', !this.$v.$invalid);
        },
    },
};
</script>
